// import RepositoryFactory from "@/apis";
// const CMSAuthor = RepositoryFactory.cmsAuthor;
import CMSAuthor from "../../apis/cmsAuthor";

export default {
  createAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await CMSAuthor.createAuthor(payload);
        // commit("CREATE_AUTHOR", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await CMSAuthor.getAuthor(payload);

        commit("GET_AUTHOR", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await CMSAuthor.deleteAuthor(payload);
        // commit("DELETE_AUTHOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await CMSAuthor.editAuthor(payload);
        // commit("EDIT_AUTHOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
